import { useTranslation } from 'react-i18next';
import { useEffect, useState, useContext } from 'react'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import './copyInvest.css'
import AuthContext from 'contexte/AuthContext';
import Tableau from 'components/DataComponents/Tableau/Tableau';
import { COPY_INVEST_RELEASE_DATE } from 'utils/date';
import FilterComponent from 'components/Filters/FilterComponent/FilterComponent';
import { fetchSignalProvidersKpi } from 'services/copyInvestServices';

const CopyInvest = () => {

  const { t } = useTranslation();
  const { user } = useContext(AuthContext);


  const [loading, setLoading] = useState(true);
  const [fetchLimit, setFetchLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedDate, setSelectedDate] = useState({
    date1: { startDate: new Date(COPY_INVEST_RELEASE_DATE), endDate: new Date() },
    date2: { startDate: null, endDate: null },
  });
  const [kpis, setKpis] = useState([]);

  const fetchData = async () => {
    try {

      const data = await fetchSignalProvidersKpi(user, selectedDate.date1.startDate, selectedDate.date1.endDate)
      setKpis(data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (selectedDate.date1.startDate !== null && selectedDate.date1.endDate !== null) {
      fetchData()
    }
  }, [fetchLimit, page, selectedDate])

  function transformDataToTBody(data) {

    return data.map(item => {
      const fullName = `${item.firstName} ${item.lastName}`;
      return {
        data: [
          fullName,
          item.cash_available,
          `${item.active_followers}   ( +${item.new_follows} / -${item.unfollows} )`,
          item.total_invested,
          item.volume,
          item.profit,
          item.followers_pnl
        ],
        utils: { id: `/signal-provider/${item.signal_provider_uuid}?sp_name=${fullName}` }
      }
        ;
    });
  }



  return (
    <DashboardLayout page={t("pages_name.copy_invest")}>
      <div>
        <h1>{t('pages.copy_invest.title')}</h1>
        {!loading ? (
          <div>
            <div className='copy_invest_title_component'>
              <div className='copy_invest_filter_component'>

                <FilterComponent
                  limit={true} date={true}
                  fetchLimit={fetchLimit} setFetchLimit={setFetchLimit}
                  selectedDate={selectedDate} setSelectedDate={setSelectedDate}
                />
              </div>
            </div>
            <Tableau
              thead={["Signal Provider", "Cash available", "Followers (Evolution sur timeframe)", "Total Investi", "Volume", "Profit", "Followers Pnl"]}
              tbody={transformDataToTBody(kpis)}
              limit={fetchLimit}
              pagination setPage={setPage} page={page}
              hadLink linkPath={"/copy-invest"}
            />
          </div>
        ) : (
          <div>Loading..</div>
        )}
      </div>
    </DashboardLayout>
  )
}

export default CopyInvest